import { gql, TypedDocumentNode } from "@apollo/client";

import { SearchSuggestionsPossibleValuesString, QuerySearchContextsSuggestionsArgs } from "types/generated";

type SearchContextsSuggestionsData = {
  searchContextsSuggestions: {
    fields: {
      possibleValuesString: Pick<SearchSuggestionsPossibleValuesString, "values"> | null;
    }[];
  };
};

export const SEARCH_CONTEXTS_NAME_SUGGESTIONS: TypedDocumentNode<
  SearchContextsSuggestionsData,
  QuerySearchContextsSuggestionsArgs
> = gql`
  query SearchContextsSuggestions($input: SearchSuggestionsInput!) {
    searchContextsSuggestions(input: $input) {
      fields {
        possibleValuesString {
          values
        }
      }
    }
  }
`;
